// extracted by mini-css-extract-plugin
export default {"criteriaGroup":"criteriaGroup_criteriaGroup__hmVqQ","criteriaGroupName":"criteriaGroup_criteriaGroupName__QAFiC","selectCurrency":"criteriaGroup_selectCurrency__HKBZn"};